<template>
    <b-dropdown :disabled="!enabled" class="pl-1 ml-0 my-2" variant="primary">
        <template v-slot:button-content>
            With {{ selection.length }} {{ schema.verbose_name_plural }}
        </template>
        <b-dropdown-item
            @click="mergeSelected"
            v-if="enableMerge && multiple_selected"
            >Merge {{ selection.length }}
            {{ schema.verbose_name_plural }}
        </b-dropdown-item>
        <b-dropdown-item @click="deleteSelected" v-if="enableDelete"
            >Delete {{ selection.length }}
            {{ schema.verbose_name_plural }}
        </b-dropdown-item>
    </b-dropdown>
</template>

<script>
export default {
    name: "OListMultiActions",
    props: {
        selection: { type: Array, default: () => [] },
        schema: { type: Object, default: null },

        enableDelete: { type: Boolean, default: false },
        deleteMessage: {
            type: String,
            default: "Are you sure you want to delete these items?",
        },
        deleteTitle: { type: String, default: "Deleting Items" },
        deleteConfirmText: { type: String, default: "Delete Items" },

        enableMerge: { type: Boolean, default: false },
        mergeTitle: { type: String, default: "Merging Items" },
        mergeMessage: {
            type: String,
            default: "Are you sure you want to merge these items?",
        },
        mergeConfirmText: { type: String, default: "Merge" },
    },
    methods: {
        deleteSelected() {
            var options = {
                title: this.deleteTitle,
                headerBgVariant: "danger",
                size: "sm",
                buttonSize: "sm",
                okVariant: "danger",
                okTitle: this.deleteConfirmText,
                cancelVariant: "success",
                cancelTitle: "Cancel",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
            };
            this.$bvModal
                .msgBoxConfirm(this.deleteMessage + "", options)
                .then((value) => {
                    if (value) {
                        this.$emit("delete", this.selection);
                    }
                });
        },
        mergeSelected() {
            var options = {
                title: this.mergeTitle,
                headerBgVariant: "warning",
                size: "sm",
                buttonSize: "sm",
                okVariant: "warning",
                okTitle: this.mergeConfirmText,
                cancelVariant: "secondary",
                cancelTitle: "Cancel",
                footerClass: "p-2",
                hideHeaderClose: false,
                centered: true,
            };
            this.$bvModal
                .msgBoxConfirm(this.mergeMessage + "", options)
                .then((value) => {
                    if (value) {
                        this.$emit("merge", this.selection);
                    }
                });
        },
    },
    computed: {
        enabled() {
            return this.selection != null && this.selection.length > 0;
        },
        multiple_selected() {
            return this.selection != null && this.selection.length > 1;
        },
    },
};
</script>
